import React from 'react'
import { MessageBoxElement } from './types'

export interface Host {
  push: (messageBox: MessageBoxElement) => void
  pop:  () => void
}


export default React.createRef<Host | null>()